const updateSearchParams = (newSearchParam: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set('search', newSearchParam);
    window.history.pushState({}, '', url);
};

export default updateSearchParams;
